// TODO: REFACTORING
import React, { useState, useRef, useEffect } from 'react';
import Style from '../../style.module.css';
import Slider from 'react-slick';
import AircraftPageOptions from '@components/AircraftPageOptions';
import { translate as t } from '@utils/translate';

const AircraftGallerySlider = ({
  images,
  flightPage,
  className,
  toggleModal,
  featuredSliderRef,
  navSliderRef,
}) => {
  const [hasOpenedOnce, setHasOpenedOnce] = useState(false);
  const [slickGoIndex, setSlickGoIndex] = useState(null);
  const [galleryOpened, setGalleryModal] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [slidersRef, setSlidersRef] = useState({
    featuredSlider: null,
    navSlider: null,
  });
  const { featuredSlider, navSlider } = slidersRef;
  useEffect(() => {
    setSlidersRef({
      featuredSlider: featuredSliderRef.current,
      navSlider: navSliderRef.current,
    });
  }, []);

  const featuredSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    draggable: false,
  };

  const navSliderSettings = {
    slidesToShow: images.length - 1,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    swipeToSlide: true,
    beforeChange: (o, newIndex) => {
      setActiveSlide(newIndex);
    },
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: images.length - 1 <= 7 ? images.length - 1 : 7,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: images.length - 1 <= 5 ? images.length - 1 : 5,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: images.length - 1 <= 3 ? images.length - 1 : 3,
        },
      },
    ],
  };
  const TEXTS = {
    CLOSE_LABEL: t('close'),
  };
  return (
    <div className={[Style.galleryContainer, 'container'].join(' ')}>
      <div className={Style.galleryModalHeader}>
        <div
          className={Style.closeContainer}
          onClick={() => toggleModal(false)}
        >
          <div className={Style.closeButton} />
          <span className={Style.closeLabel}>{TEXTS.CLOSE_LABEL}</span>
        </div>
        <div className={Style.galleryCounter}>
          {activeSlide + 1}/{images.length}
        </div>
        <div className={Style.pageOptions}>
          <AircraftPageOptions />
        </div>
      </div>
      <Slider
        className={Style.featuredSlider}
        asNavFor={navSlider}
        ref={featuredSliderRef}
        {...featuredSliderSettings}
      >
        {images.map(({ url, label, description }, index) => {
          return (
            <div className={Style.featuredSlide} key={index}>
              <div className={Style.imageContainer}>
                <img src={url} alt={label} />
              </div>
              <div className={Style.featuredSlideContent}>
                <p className={Style.featuredSlideLabel}>{label}</p>
                <p className={Style.featuredSlideDescription}>{description}</p>
              </div>
            </div>
          );
        })}
      </Slider>
      <Slider
        className={Style.navSlider}
        asNavFor={featuredSlider}
        ref={navSliderRef}
        {...navSliderSettings}
      >
        {images.map(({ label, url }, index) => (
          <img key={index} width="129px" height="75px" src={url} alt={label} />
        ))}
      </Slider>
    </div>
  );
};

export default AircraftGallerySlider;
